import { Button } from "./Button";

export function pageCount(total: number, pageSize: number): number {
  return Math.max(1, Math.ceil(total / pageSize));
}

export function pageItems<Item>(
  items: readonly Item[],
  page: number,
  pageSize: number,
): Item[] {
  const currentPage = Math.min(
    Math.max(1, page),
    pageCount(items.length, pageSize),
  );
  const start = (currentPage - 1) * pageSize;
  return items.slice(start, start + pageSize);
}

export function Pagination({
  page,
  pageSize,
  total,
  ariaLabel,
  onPageChange,
}: {
  page: number;
  pageSize: number;
  total: number;
  ariaLabel: string;
  onPageChange: (page: number) => void;
}) {
  const pages = pageCount(total, pageSize);
  if (pages <= 1) return null;

  const currentPage = Math.min(Math.max(1, page), pages);
  const start = (currentPage - 1) * pageSize + 1;
  const end = Math.min(total, currentPage * pageSize);

  return (
    <nav className="ui-pagination" aria-label={ariaLabel}>
      <span>
        {start.toLocaleString()}–{end.toLocaleString()} of{" "}
        {total.toLocaleString()}
      </span>
      <div className="ui-pagination__controls">
        <Button
          tone="quiet"
          disabled={currentPage === 1}
          onClick={() => onPageChange(currentPage - 1)}
        >
          Previous
        </Button>
        <span>
          Page {currentPage.toLocaleString()} of {pages.toLocaleString()}
        </span>
        <Button
          tone="quiet"
          disabled={currentPage === pages}
          onClick={() => onPageChange(currentPage + 1)}
        >
          Next
        </Button>
      </div>
    </nav>
  );
}
